module.exports = __webpack_public_path__ + "img/2.198aa1d0.png";